import { inject, Injectable } from '@angular/core';

import { UIService } from '../../services/ui.service';
import { getLogLevelFromString } from '../log-levels';
import { defaultLoggerOptions, LoggerOptions } from '../logger-options';

@Injectable({
  providedIn: 'root',
})
export class LoggerConfigService {
  private readonly uiService = inject(UIService);
  private loggerOptions!: LoggerOptions;

  getLoggerOptions(): LoggerOptions {
    if (!this.loggerOptions) {
      this.loggerOptions = this.initLoggerOptions();
    }
    return this.loggerOptions;
  }

  initLoggerOptions() {
    const options = this.uiService.environmentService.environment.loggerOptions;
    if (options) {
      if (options.minLogLevel && typeof options.minLogLevel === 'string') {
        options.minLogLevel = getLogLevelFromString(options.minLogLevel as string);
      }
      if (options.moduleLogLevels) {
        for (const module in options.moduleLogLevels) {
          if (Object.prototype.hasOwnProperty.call(options.moduleLogLevels, module)) {
            const level = options.moduleLogLevels[module];
            if (typeof level === 'string') {
              options.moduleLogLevels[module] = getLogLevelFromString(level);
            }
          }
        }
      }
      return options;
    } else {
      return defaultLoggerOptions;
    }
  }
}
